// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1Mj7N","dragIcon":"SortableItem_dragIcon__1n3t0","disabled":"SortableItem_disabled__J7U2_"};